import React from "react";
import { Box } from "@mui/material";
import { COLORS, Label12Regular } from "components";

import { ReplyControlsProps } from "./types";

export const ReplyControls = ({
  comment,
  isReplying,
  setIsReplying,
  shouldShowReplies,
  setShouldShowReplies,
}: ReplyControlsProps) => (
  <Box
    sx={{
      display: "flex",
      gap: 2,
      justifyContent: "flex-end",
      alignItems: "center",
    }}>
    <Label12Regular
      sx={{
        color: COLORS.black,
        cursor: "pointer",
      }}
      onClick={() => setIsReplying(!isReplying)}
    >
      Reply
    </Label12Regular>
    {comment.replies.length !== 0 && (
      <Label12Regular
        sx={{
          color: COLORS.black,
          cursor: "pointer",
        }}
        onClick={() => setShouldShowReplies(!shouldShowReplies)}
      >
        {shouldShowReplies ? "Hide" : "Show"} replies (
        {comment.replies.length})
      </Label12Regular>
    )}
  </Box>
);